import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'min(92vw, 960px)',
    maxHeight: '92vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    overflow: 'hidden',
    outline: 'none',
};

export default function BasicModal({ open, handleClose }) {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-label="Video institucional de Laboratorio Sertex"
        >
            <Box sx={modalStyle}>
                <IconButton
                    onClick={handleClose}
                    aria-label="Cerrar video"
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 1,
                        bgcolor: 'rgba(255,255,255,0.9)',
                        color: '#2A4E9C',
                        '&:hover': { bgcolor: '#fff', color: '#d32f2f' },
                        transition: 'color .2s ease',
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* Contenedor 16:9 responsive: el video nunca se deforma ni queda con bandas negras raras */}
                <Box sx={{ position: 'relative', width: '100%', pt: '56.25%' }}>
                    <Box
                        component="iframe"
                        title="Video institucional Laboratorio Sertex"
                        src="https://www.youtube.com/embed/SdMbKlXdeLI?controls=0&start=1&autoplay=1"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            width: '100%',
                            height: '100%',
                            border: 0,
                        }}
                    />
                </Box>
            </Box>
        </Modal>
    );
}
